/**
 * created by Felicia Dumitrache
 */
import BaseComponent from "../../base/base_component";
import GameHostComponent from "../game_host/game_host_component_controller";
import _ from "../../utils/underscore";

export default class AffiliatesGameHostComponent extends BaseComponent{
    /**
     * @type {string}
     */
    static CLASS = "AffiliatesGameHostComponent";

    /**
     * @type {string}
     */
    static DIRECTIVE = "cgp-directive-affiliates_game_host";

    /**
     * game type sent by affiliate via dataset
     * @type {String}
     * @private
     */
    _gameType = null;

    /**
     * used for timeout message
     * @type {Observable}
     * @private
     */
    _showMessageObservable = null;

    /**
     * init the component and set gameType received in params
     * @param params {Object}
     */
    init(params={}){
        super.init(params);
        if(_.isNullOrUndefined(params.gametype)) {
            this.throwArgumentExpected('40', 'init', 'gametype');
        }
        this._gameType = params.gametype;
    }

    /**
     * create Host Game component which open game and start timout message
     */
    start() {
        if (this.serviceFactory.regulationService().isAnonymousPlayAllowed()){
          this.appendChildComponent(GameHostComponent.create({gameType: this._gameType}).start());
          this._startTimeout();
        } else {
          this._showRestrictedGameMessage();
        }
    }

  /**
   * show Go to lobby message and set actions and callbacks for buttons
   * @private
   */

    _showRestrictedGameMessage(){
      this.serviceFactory.structuredLoggingService().getLogger({
        eventName: 'GAME_PREVENTED_COUNTRY_BLOCK_AFFILIATES'
      }).info();
      this.serviceFactory.messageManagerService().openMessage({
        closeButton: false,
        title: this.serviceFactory.languageService().translation('demo_restricted_title'),
        text: this.serviceFactory.languageService().translation('demo_restricted_message'),
        buttons: [{
          name: this.serviceFactory.languageService().translation('demo_restricted_btn'),
          isClosable: false,
          callback: () => {
            this.serviceFactory.structuredLoggingService().getLogger({
              eventName: 'GO_TO_LOBBY_GAME_COUNTRY_BLOCKED_AFFILIATES'
            }).info();
            this._goToLobby();
          }
        }]
      });
    }

    /**
     * start timeout for displaying message
     * @private
     */
    _startTimeout(){
        let interval = this.serviceFactory.gameService().getAffiliatesGoToLobbyInterval();
        this._showMessageObservable = this.serviceFactory.observableFactoryService().fromTimeout(interval)
            .forEach(() => {
                this._clearTimeout();
                this._showGoToLobbyMessage();
            })
    }

    /**
     * show Go to lobby message and set actions and callbacks for buttons
     * @private
     */
    _showGoToLobbyMessage(){
        this.serviceFactory.messageManagerService().openMessage({
            closeButton: true,
            title: this.serviceFactory.languageService().translation('go_to_lobby_title'),
            text: this.serviceFactory.languageService().translation('go_to_lobby_message'),
            buttons: [{
                name: this.serviceFactory.languageService().translation('go_to_lobby_btn'),
                isClosable: true,
                callback: () => {
                    this._goToLobby();
                }
            }],
            btnCloseCallback: () => {
                this._clearTimeout();
                this._startTimeout();
            }
        });
    }

    /**
     * method called when click on Go To Lobby button
     * opens Lobby in new browser tab
     * @private
     */
    _goToLobby(){
        this.serviceFactory.openLinkService().goToLobby();
    }

    /**
     * clears the message timeout
     * @private
     */
    _clearTimeout() {
        if (this._showMessageObservable) {
            this._showMessageObservable.dispose();
            this._showMessageObservable = null;
        }
    }
}